const SectionIconBoxesLayout2 = () => {
  return (
    <>
      <section className="">
        <div className="container mx-auto px-4">
          <div className="flex justify-center">
            <div className="text-center lg:w-3/5">
              <h2 className="mb-12 text-xl font-bold md:text-2xl text-[#011473] lg:text-3xl">
                Immigration - Select Your Preferred{" "}
                <span className="text-[#FA6262]">Country with Visa World</span>
              </h2>
            </div>
          </div>
          <div className="mx-auto mb-20 flex max-w-7xl flex-wrap justify-center gap-4 lg:justify-between">
            {/* Image 1 */}
            <div className="relative w-full max-w-md transform rounded border p-4 shadow-md transition-transform duration-500 hover:scale-105 lg:w-[30%]">
              {/* Main Image */}
              <img
                className="h-48 w-full rounded-lg object-cover shadow-lg"
                src="canadas.jpg"
                alt="Canada Main"
              />

              {/* Circle Image at bottom-right */}
              <div className="absolute right-5 top-36 translate-x-1/4 translate-y-1/4 transform sm:right-10 sm:top-40">
                <img
                  className="h-16 w-16 rounded-full border-4 border-white shadow-md"
                  src="canada.png"
                  alt="Canada Circle"
                />
              </div>

              {/* Text for Image 1 */}
              <div className="ml-2 mt-5 text-left text-2xl font-bold text-black">
                Canada
              </div>
              <div className="ml-2 mt-2 text-left text-sm text-black">
                Discover immigration pathways with Visa World to Canada, a
                country admired for its breathtaking landscapes and thriving
                economy. Canada provides a rich multicultural environment and an
                outstanding quality of life.
              </div>

              {/* Read More Button */}
              <div className="mt-4 flex items-center">
                <a
                  href="canada"
                  className="flex items-center text-[#01012f] hover:text-[#01012f]"
                >
                  <span className="ml-2">Read more</span>
                  <span className="ml-2 inline-flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#01012f]">
                    <span className="h-2 w-2 rotate-45 transform border-r-2 border-t-2 border-[#01012f]"></span>
                  </span>
                </a>
              </div>
            </div>

            {/* Image 2 */}
            <div className="relative w-full max-w-md transform rounded border p-4 shadow-md transition-transform duration-500 hover:scale-105 lg:w-[30%]">
              {/* Main Image */}
              <img
                className="h-48 w-full rounded-lg object-cover shadow-lg"
                src="usai.jpg"
                alt="USA Main"
              />

              {/* Circle Image at bottom-right */}
              <div className="absolute right-5 top-36 translate-x-1/4 translate-y-1/4 transform sm:right-10 sm:top-40">
                <img
                  className="h-16 w-16 rounded-full border-4 border-white shadow-md"
                  src="usaa.png"
                  alt="USA Circle"
                />
              </div>

              {/* Text for Image 2 */}
              <div className="ml-2 mt-5 text-left text-2xl font-bold text-black">
                USA
              </div>
              <div className="ml-2 mt-2 text-left text-sm text-black">
                The United States offers a high standard of living with abundant
                opportunities. Known for its dynamic economy and diverse
                culture, the USA is a prime choice for skilled migrants seeking
                new career prospects and a better quality of life.
              </div>

              {/* Read More Button */}
              <div className="mt-4 flex items-center">
                <a
                  href="usa"
                  className="flex items-center text-[#01012f] hover:text-[#01012f]"
                >
                  <span className="ml-2">Read more</span>
                  <span className="ml-2 inline-flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#01012f]">
                    <span className="h-2 w-2 rotate-45 transform border-r-2 border-t-2 border-[#01012f]"></span>
                  </span>
                </a>
              </div>
            </div>

            {/* Image 3 */}
            <div className="relative w-full max-w-md transform rounded border p-4 shadow-md transition-transform duration-500 hover:scale-105 lg:w-[30%]">
              {/* Main Image */}
              <img
                className="h-48 w-full rounded-lg object-cover shadow-lg"
                src="ukh.jpg"
                alt="UK Main"
              />

              {/* Circle Image at bottom-right */}
              <div className="absolute right-5 top-36 translate-x-1/4 translate-y-1/4 transform sm:right-10 sm:top-40">
                <img
                  className="h-16 w-16 rounded-full border-4 border-white shadow-md"
                  src="uks.png"
                  alt="UK Circle"
                />
              </div>

              {/* Text for Image 3 */}
              <div className="ml-2 mt-5 text-left text-2xl font-bold text-black">
                UK
              </div>
              <div className="ml-2 mt-2 text-left text-sm text-black">
                Experience life in the UK, from vibrant urban centers like
                London and Manchester to charming rural landscapes. Benefit from
                excellent healthcare, education, and public services while
                immersing yourself in a culturally rich and diverse society.
              </div>

              {/* Read More Button */}
              <div className="mt-4 flex items-center">
                <a
                  href="uk"
                  className="flex items-center text-[#01012f] hover:text-[#01012f]"
                >
                  <span className="ml-2">Read more</span>
                  <span className="ml-2 inline-flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#01012f]">
                    <span className="h-2 w-2 rotate-45 transform border-r-2 border-t-2 border-[#01012f]"></span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionIconBoxesLayout2;
